import { Component, OnInit } from '@angular/core';
import { Session } from 'src/app/models/session';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { DatePipe, getLocaleFirstDayOfWeek } from '@angular/common';
import { isNumber } from 'util';

@Component({
  selector: 'app-new-ticket',
  templateUrl: './new-ticket.component.html',
  styleUrls: ['./new-ticket.component.css']
})
export class NewTicketComponent implements OnInit {

  constructor(public session: Session, private toast: ToastrService, private service: UserService) { }

  newTicket;
  selectedZona;
  selectedProvincia;

  initErrors = 0;
  todaysdate = new Date();

  provincias = [];
  zonas = [];

  step = 1;

  productos = [];

  ngOnInit() {
    
    this.service.getProductos().subscribe(d=>{
      this.productos = d.productos;
    }, er=>{
      this.initErrors = 1;
    });
    this.service.getZones().subscribe(d=>{
      this.session.zonas = d;
      this.resetNewTicket();
      this.getProvincias();
    }, er=>{
      this.initErrors = 1;
    });
  }

  mockTicket(){
    if(this.newTicket.nombre != "prueba") return;
    // console.log(this.getDiagnostico());
    
    this.selectedProvincia =  this.session.zonas[0].provincia;
    this.getZonas();
    this.selectedZona =  this.zonas[0];
    let aux = (new Date()).getTime();
    this.newTicket = {
      nombre: "Usuario",
      apellido: "Prueba",
      factura_informada_en_alta: { empresa: "EmpresaPrueba", numero:"123123123", fecha: "01/01/2000"},
      calle: "Calle falsa",
      numero: "1234",
      telefono: "5555 5555",
      codArea: "11",
      piso: "8J",
      cp: "1428",
      garantia: "222222122222222",
      email: "esubissi@gmail.com",
      fecha: "",
      barrio: "Albuquerque",
    }
    var datePipe = new DatePipe("en-US");
    this.newTicket.fecha = datePipe.transform(new Date(), 'yyyy-MM-dd');
    
  }

  diagnostico = {
    electrodomestico: "Freezer",
    falla_tipo: "Eléctrico",

    electrico_1: false,
    electrico_2: false,
    electrico_3: false,

    frigorifico_1: false,
    frigorifico_2: false,
    frigorifico_3: false,
    frigorifico_4: false,
    frigorifico_5: false,
    frigorifico_6: false,
    frigorifico_7: false,
    frigorifico_8: false,
    frigorifico_9: false,
    frigorifico_10: false,

    estetico_1: false,
    estetico_2: false,
    estetico_3: false,

    otro_1: false,
    otro_texto: ""

  }

  getProvincias(){
    for(let z of this.session.zonas){
      if(this.provincias.indexOf(z.provincia)<0) this.provincias.push(z.provincia);
    }

    this.provincias.sort( (a,b) => { return a > b ? 1: -1 });
    
  }

  selectedProvinciaChanged(){
    this.getZonas();
    this.selectedZona = this.zonas[0];
  }

  getZonas(){
    this.zonas =  this.session.zonas.filter(x=> x.provincia == this.selectedProvincia).sort( (a,b) => { return a.localidad > b.localidad ? 1 : -1 });    
  }


  resetNewTicket(){
    var datePipe = new DatePipe("en-US");
    this.newTicket = {
      nombre: "",
      apellido: "",
      calle: "",
      numero:"",
      telefono: "",
      codArea: "",
      factura_informada_en_alta: { empresa: "", numero:"", fecha: ""},
      garantia: "",
      cp: "",
      piso: "",
      email: "",
      fecha: datePipe.transform(new Date(), 'yyyy-MM-dd'),
      barrio: "",
      selectedZona: JSON.parse(JSON.stringify(this.session.zonas[0]))
    }
    // console.log(this.newTicket);
    
  }

  borrarGarntia = false;
  operationId = "";
  ticket_id ="";
  addTicket(){
    if(this.newTicket.calle.length<1) return this.toast.error("Calle inválida");
    if(this.newTicket.numero.length<1) return this.toast.error("Número inválido");
    if(this.newTicket.barrio.length<1){
      return this.toast.error("Barrio inválido");
    }
    console.log(this.newTicket.fecha);
    
    if(!this.newTicket.fecha || this.newTicket.fecha.length<10){
      return this.toast.error("Fecha pretendida inválida");
    }
    this.operationId = "";
    let z = JSON.parse(JSON.stringify(this.selectedZona));
    let t = {
      nombre: this.newTicket.nombre,
      apellido: this.newTicket.apellido,
      garantia: this.newTicket.garantia,
      fecha: this.newTicket.fecha,
      domicilio: this.newTicket.calle  + " " + this.newTicket.numero,
      factura_informada_en_alta: this.newTicket.factura_informada_en_alta,
      telefono: this.newTicket.codArea + this.newTicket.telefono,
      email: this.newTicket.email,
      zona: z,
      comentario: this.getDiagnostico(),
      producto: this.newTicket.producto,
      barrio: this.newTicket.barrio
    }
    t.telefono = "+54" + t.telefono;

    if(this.newTicket.piso) t.domicilio+= " " + this.newTicket.piso;
    if(this.newTicket.cp) t.domicilio+= " (CP: " + this.newTicket.cp + ")"

    if(this.borrarGarntia){
      t.garantia ="";
    }
    
    // console.log(t);

    
    this.service.postTicket(t).subscribe(d=>{
      this.resetNewTicket();
      this.step = 4;
      this.operationId = d.code;
      this.ticket_id = d.ticket_id;
    }, er=>{
      this.toast.error(er.error);
    })
  }


  getDiagnostico(){
    let ret = "Diagnostico: ";
    ret+="\Electrodoméstico : " + this.diagnostico.electrodomestico;
    ret+="\nFalla: " + this.diagnostico.falla_tipo;

    if(this.diagnostico.falla_tipo=="Eléctrico"){
      if(this.diagnostico.electrico_1) ret+="\n" + "El producto no arranca";
      if(this.diagnostico.electrico_2) ret+="\n" + "El producto está conectado a la red electrica en forma directa (Sin zapatilla, adaptadores, etc)";
      if(this.diagnostico.electrico_3) ret+="\n" + "La luz del interior funciona";
    }

    if(this.diagnostico.falla_tipo=="Frigorífico"){
      if(this.diagnostico.frigorifico_1) ret+="\n" + "El producto no enfría";
      if(this.diagnostico.frigorifico_2) ret+="\n" + "El producto genera o tiene condensación";
      if(this.diagnostico.frigorifico_3) ret+="\n" + "El producto genera hielo en exceso";
      // if(this.diagnostico.frigorifico_4) ret+="\n" + "El producto genera o tiene condensación EXTERNA en puerta y/o zona de apoyo de la misma";
      // if(this.diagnostico.frigorifico_5) ret+="\n" + "El producto genera o tiene condensación EXTERNA en el gabinete (techo y/o laterales)";
      // if(this.diagnostico.frigorifico_6) ret+="\n" + "El producto genera o tiene condensación EXTERNA en la zona del motor";
      // if(this.diagnostico.frigorifico_7) ret+="\n" + "El producto genera o tiene condensación INTERNA en el freezer";
      // if(this.diagnostico.frigorifico_8) ret+="\n" + "El producto genera o tiene condensación INTERNA en el refrigerador";
      // if(this.diagnostico.frigorifico_9) ret+="\n" + "El producto genera o tiene condensación INTERNA en la zona del desagüe";
      // if(this.diagnostico.frigorifico_10) ret+="\n" + "El producto genera hielo en exceso";
    }

    if(this.diagnostico.falla_tipo=="Estético"){
      if(this.diagnostico.estetico_1) ret+="\n" + "El producto está golpeado, rayado o roto";
      if(this.diagnostico.estetico_2) ret+="\n" + "El producto tiene componentes faltantes";
      if(this.diagnostico.estetico_3) ret+="\n" + "El cable de alimentación se encuentra dañado";
      
    }

    if(this.diagnostico.falla_tipo=="Otro"){
      if(this.diagnostico.otro_1) ret+="\n" + "El producto hace ruidos anormales\n";
      ret+="\n" + this.diagnostico.otro_texto;
      
    }

    return ret;
  }


  nextStep(){
    if(this.step==1){
      if(this.newTicket.nombre.length<1) return this.toast.error("Nombre ingresado inválido");
      if(this.newTicket.apellido.length<1) return this.toast.error("Apellido ingresado inválido");
      if(this.newTicket.telefono.length<1) return this.toast.error("Telefono ingresado inválido");
      if(this.newTicket.codArea.length<1) return this.toast.error("Código de area ingresado inválido");
      if(this.newTicket.email.length<1) return this.toast.error("Email ingresado inválido");
      
      //FACTURA
      if(this.newTicket.factura_informada_en_alta.empresa.length<1) return this.toast.error("Empresa ingresada inválido");
      
      
      let verif_code = this.newTicket.factura_informada_en_alta.numero;
      if(verif_code.length<6) return this.toast.error("Número de factura ingresado inválido");
      for (var i = 0; i < verif_code.length; i++) {
        if(!"1234567890".includes(""+verif_code.charAt(i))) return this.toast.error("Número de factura ingresado inválido.");
      }

      if(this.newTicket.factura_informada_en_alta.numero.length<6 || isNaN(parseInt(this.newTicket.factura_informada_en_alta.numero))) return this.toast.error("Número de factura ingresado inválido");
      if(this.newTicket.factura_informada_en_alta.fecha.length!=10 || isNaN(parseInt(this.newTicket.factura_informada_en_alta.fecha.replace("-","").replace("/","")))) return this.toast.error("Fecha de emisión ingresada inválida");
      
      if(this.newTicket.garantia.length<1 && !this.noConozcoNroSerie) return this.toast.error("Numero de serie ingresado inválido");
      if(!this.newTicket.producto) return this.toast.error("El número de serie ingresado no pertenece a un producto.");

      this.hideProductTypeSelection = false;
      if(this.newTicket.producto && this.newTicket.producto.codigo){
        if(this.newTicket.producto.nombre.indexOf("HEL")>=0){
          this.diagnostico.electrodomestico = "Heladera";
          this.hideProductTypeSelection = true;
        }
        if(this.newTicket.producto.nombre.indexOf("EXH")>=0){
          this.diagnostico.electrodomestico = "Exhibidora";
          this.hideProductTypeSelection = true;
        }
        if(this.newTicket.producto.nombre.indexOf("FRE")>=0){
          this.diagnostico.electrodomestico = "Freezer";
          this.hideProductTypeSelection = true;
        }
      }
      
    }

    if(this.step==2){
      if(this.diagnostico.falla_tipo.length<1) return this.toast.error("Informa que tipo de falla tiene el electrodoméstico");
    }
    this.step++;
  }


  vigencia_ok = false;
  validarProducto(){
    this.borrarGarntia = false;
    this.newTicket.producto = null;
    this.vigencia_ok = false;

    if(this.newTicket.garantia.length!=15) return;
    if(!(/^\d+$/.test(this.newTicket.garantia))) return;

    this.newTicket.producto = this.productos.find(x=> this.newTicket.garantia.startsWith(x.barcode));
    let semana = this.newTicket.garantia.substring(6,8);
    let ano = this.newTicket.garantia.substring(8,9);
    ano = Number.parseInt(ano) + 2020;
    if(ano> (new Date().getFullYear())) ano-=10;

    

    let fecha = this.getDateOfWeek(semana, ano);
    console.log(fecha);
    
    let dif = ( (new Date().getTime()) - fecha.getTime()  ) / 1000;


    //le resto a dif los 60 dias de channgui
    dif-=5184000;

    this.vigencia_ok =  dif < 31536000 && dif >-5184000; 
  }

  getDateOfWeek(w, y) {
    var d = (1 + (w - 1) * 7);
    return new Date(y, 0, d);
}
  


noConozcoNroSerie(){
  this.borrarGarntia = true;
  this.newTicket.producto = { };  
}

hideProductTypeSelection = false;
// 052301289052073

  getFabricacion(){
    let ano = 2020 + parseInt(this.newTicket.garantia.substring(8,9));
    if(ano> (new Date().getFullYear())) ano-=10;
    let semana = this.newTicket.garantia.substring(6,8) 
    let ret = 'Frabricado: Semana ' + semana + ' de ' + ano; 
    console.log(ret);
    return ret;
  }


  agregarCeros(){
    while(this.newTicket.factura_informada_en_alta.numero.length<6) this.newTicket.factura_informada_en_alta.numero =  "0" + this.newTicket.factura_informada_en_alta.numero;
    
  }
}
